import { VehicleMapDataPoint } from "../api/types/VehicleMap";
import { VehicleStatusCode } from "../api/types/VehicleStatusCode";
import { store } from "../api/store/store";
import { titleCase } from "./string";

export const getVehicleEventStatusCodeKey = (
  tripPoint: Partial<VehicleMapDataPoint>
) =>
  Object.keys(VehicleStatusCode).find(
    (key) =>
      VehicleStatusCode[key as keyof typeof VehicleStatusCode] ===
      tripPoint.statuscode
  );

export const getVehicleEventStatusDisplayName = (
  tripPoint: Partial<VehicleMapDataPoint>,
  statusCodeKey?: string,
  isMotionStartStopVehicle: Boolean = false
) => {
  const key = statusCodeKey || getVehicleEventStatusCodeKey(tripPoint);
  let displayName = key
    ?.replace("STATUS_", "")
    ?.replace(/_/g, " ")
    ?.toLowerCase();

  if (displayName === "motion enroute" || displayName === "motion moving") {
    displayName = "driving";
  } else if (displayName === "motion heading") {
    displayName = "heading change";
  } else if (displayName === "impact") {
    displayName = "possible impact";
  }

  displayName =
    displayName
      ?.replace(
        "ignition on",
        `${isMotionStartStopVehicle ? "Motion Start" : "Ignition ON"}`
      )
      ?.replace(
        "ignition off",
        `${isMotionStartStopVehicle ? "Motion Stop" : "Ignition OFF"}`
      )
      ?.replace("motion stopped", "Stopped")
      ?.replace("motion stop", "Stopped")
      ?.replace("motion idle", "Idle") || "";

  return titleCase(displayName);
};

export const consistentDisplayAssetItem = (
  deviceid?: string | null,
  description?: string | null,
  displayName?: string | null,
  driverName?: string | null,
  showDriver: boolean = true
): string => {
  const valueByField: Record<string, string | null | undefined> = {
    deviceid,
    description,
    displayname: displayName,
    drivername: driverName,
  };

  const defaultFieldOrder = showDriver
    ? ["deviceid", "description", "displayname", "drivername"]
    : ["deviceid", "description", "displayname"];

  const configuredAssetLabelFields =
    store
      .getState()
      ?.commonReducer?.account?.asset_label_fields?.split(",")
      .map((item) => item.trim().toLowerCase())
      .filter((item) => !!item) ?? [];

  const normalizedConfiguredFields = configuredAssetLabelFields
    .map((field) => {
      if (["device_id", "asset_id", "assetid"].includes(field)) {
        return "deviceid";
      }
      if (["display_name"].includes(field)) {
        return "displayname";
      }
      if (["driver", "driver_name"].includes(field)) {
        return "drivername";
      }
      return field;
    })
    .filter((field) => Object.keys(valueByField).includes(field));

  const uniqueConfiguredFields = Array.from(
    new Set(normalizedConfiguredFields)
  );
  const configuredFieldOrder = showDriver
    ? uniqueConfiguredFields
    : uniqueConfiguredFields.filter((field) => field !== "drivername");

  const fieldOrder = configuredFieldOrder.length
    ? configuredFieldOrder
    : defaultFieldOrder;

  const parts = fieldOrder.map((field) => valueByField[field]);

  return parts
    .map((val) => (val && val.trim() !== "" ? val : "N/A"))
    .join(" | ");
};
